import { ReactElement } from 'react';

import { Value } from '@philips-emr/tws-core';
import Controller, { OnClick, OnDynamicContentRender, OnSelectItem } from '@philips-emr/tws-core/lib/client';
import { RenderEvent, SelectItemEvent } from '@philips-emr/tws-core/lib/component/types';

import { ChamadosAliases, FragmentNames } from '../../codegen';
import { Routes } from '../../definitions/routes';
import BaseController from '../base/base-controller';

import { CallsData, getStampByStatus } from './chamado-utils';

interface Call {
  nrSeqCall: number;
  dsStatus: string;
  dsJustificationCloseCall: string;
  nrSequenceCallType: number;
  guidance: string;
  dtClose: string,
}

@Controller({ fragment: FragmentNames.CHAMADOS })
class ChamadosController extends BaseController {

  @OnClick(ChamadosAliases.ACTION_NEW_CALL)
  onClickNewCall(): void {
    this.historyService.push(Routes.TIPO_CHAMADO);
  }

  @OnDynamicContentRender('hpms-custom-card-calls')
  onDynamicContentRenderCardCall(event: RenderEvent): void {
    const { data, render } = event;
    const { cdStatus, dsStatus } = data as CallsData;
    const content = (): ReactElement => (getStampByStatus(cdStatus, dsStatus));
    render(content);
  }

  @OnSelectItem('deck-calls')
  public onSelectItemCall(event: SelectItemEvent<Record<string, Value>>): void {
    const data = event.item as unknown as Call;
    this.details(data.nrSeqCall);
  }

  private details(nrSeqCall: number): void {
    this.historyService.push(Routes.DETALHES_CHAMADO, { nrSeqCall });
  }

}

export {
  ChamadosController,
  Call,
};
